package br.com.texeratx.boardgametimeapp.domain.usecases.games

import br.com.texeratx.boardgametimeapp.data.model.game.GameCategoryDTO
import br.com.texeratx.boardgametimeapp.data.repository.GameRepository

class GetGameCategoriesUseCase(
    private val repository: GameRepository
) {
    suspend operator fun invoke(): Result<List<GameCategoryDTO>> =
        repository.getGameCategories()
}
